exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copy-guids .mocked-button {\n  cursor: auto;\n}\n", ""]);

// exports
